import SvgIcon from 'material-ui/SvgIcon';
import React from 'react';

const ArrowDown = (props) => (<SvgIcon {...props}>
    <path d="M7 10l5 5 5-5z"/>
    <path d="M0 0h24v24H0z" fill="none"/>
    </SvgIcon>
);

export default ArrowDown;



// WEBPACK FOOTER //
// ./src/icons/ArrowDown.jsx